import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useArchivedChats } from '../hooks/useArchivedChats';
import { ArchivedChatList } from '../components/chat/ArchivedChatList';
import { LoadingState } from '../components/ui/LoadingState';
import { ErrorState } from '../components/ui/ErrorState';
import { EmptyState } from '../components/ui/EmptyState';
import { useColors, ThemeColors } from '../hooks/useColors';

export function ArchivedChatsScreen() {
  const colors = useColors();
  const styles = createStyles(colors);
  const { data: chats, isLoading, error } = useArchivedChats();

  if (isLoading) return <LoadingState />;
  if (error) return <ErrorState error={error} />;
  if (!chats?.length) {
    return (
      <View style={styles.container}>
        <EmptyState
          icon="archive"
          title="No archived chats"
          description="Your archived chats will appear here"
        />
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <ArchivedChatList chats={chats} />
    </View>
  );
}

const createStyles = (colors: ThemeColors) => StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background,
  },
}); 